var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13739_126968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.435 9.12916L18.9268 7.62092C18.6482 7.34235 18.493 6.96827 18.493 6.5743V4.44127C18.493 3.37077 17.6255 2.50324 16.555 2.50324H14.4219C14.028 2.50324 13.6539 2.34803 13.3753 2.06947L11.8671 0.561224C11.111 -0.194887 9.88129 -0.194887 9.12518 0.561224L7.61694 2.06947C7.33837 2.34803 6.96429 2.50324 6.57032 2.50324H4.44127C3.37078 2.50324 2.50324 3.37077 2.50324 4.44127V6.57032C2.50324 6.96429 2.34803 7.33837 2.06947 7.61694L0.561224 9.12518C-0.194887 9.88129 -0.194887 11.111 0.561224 11.8671L2.06947 13.3753C2.34803 13.6539 2.50324 14.028 2.50324 14.4219V16.555C2.50324 17.6255 3.37078 18.493 4.44127 18.493H6.5743C6.96827 18.493 7.34235 18.6482 7.62092 18.9268L9.12916 20.435C9.88527 21.1911 11.1149 21.1911 11.8711 20.435L13.3793 18.9268C13.6579 18.6482 14.0319 18.493 14.4259 18.493H16.559C17.6294 18.493 18.497 17.6255 18.497 16.555V14.4219C18.497 14.028 18.6522 13.6539 18.9308 13.3753L20.439 11.8671C21.1911 11.1149 21.1911 9.88527 20.435 9.12916Z",
    fill: "#5754E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13026 12.4361H7.32241L5.94151 9.77772V12.4361H5.17346V8.56396H6.1763L7.36221 10.7806V8.56396H8.13026V12.4361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3139 12.4361H8.96204V8.56396H11.3139V9.31212H9.79376V10.1239H11.2025V10.8721H9.79376V11.6839H11.3139V12.4361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5072 8.56396L15.6317 12.4361H14.7005L14.1195 9.91303L13.5504 12.4361H12.6232L11.7477 8.56396H12.6232L13.1206 11.2303L13.7215 8.56396H14.5572L15.1263 11.2303L15.6516 8.56396H16.5072Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13739_126968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBlue);
export default __webpack_public_path__ + "static/media/newBlue.438fe78a6963901099ce4812f644f6da.svg";
export { ForwardRef as ReactComponent };